@if (currentUser$ | async; as currentUser) {
    @if (userInfo$ | async; as userInfo) {
        <app-tb-menu
            #menu
            [template]="userSettings"
            panelClass="user-settings"
            yPosition="above"
            class="w-full"
        >
            <div
                trigger
                [class]="{
                    'closed': hideName,
                    'text-primary': menu.menuOpen,
                    'text-white': !menu.menuOpen,
                    'hover:text-primary': !menu.menuOpen,
                }"
                class="group/user-settings flex items-center justify-content-between w-full p-2 rounded-lg subheading-1 cursor-pointer bg-text"
            >
                <div
                    class="absolute left-[13px] w-6 h-6 box-content rounded-full border-[3px] border-solid border-primary avatarBorder"
                    [class]="
                        menu.menuOpen
                            ? 'visible'
                            : ['invisible', 'group-hover/user-settings:visible']
                    "
                ></div>

                <div class="flex items-center p-0 cursor-pointer w-full hover:brightness-90">
                    <app-user-avatar
                        class="flex w-6 h-6"
                        [userName]="userInfo.first_name + ' ' + userInfo.last_name"
                        [userUrl]="userInfo.avatar_url"
                    >
                    </app-user-avatar>
                    @if (!hideName) {
                        <div
                            class="subheading-1 overflow-hidden max-w-[16ch] whitespace-nowrap text-ellipsis ml-4"
                        >
                            {{ userInfo.first_name }} {{ userInfo.last_name }}
                        </div>
                    }
                </div>
            </div>
        </app-tb-menu>

        <ng-template #userSettings let-containerLayout="containerLayout" let-close="closeFn">
            <app-user-settings-content
                [currentUserIsAdmin]="currentUser.is_admin"
                [userInfo]="userInfo"
                [containerLayout]="containerLayout"
                [close]="close"
            ></app-user-settings-content>
        </ng-template>
    }
}
